<template>
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Search bar -->
    <rect x="4" y="3" width="40" height="8" rx="3" stroke="#666666" stroke-width="1.2" fill="none" />
    <rect x="7" y="5.5" width="16" height="3" rx="1" fill="#D6D6D6" />
    <circle cx="37.5" cy="7" r="2.2" stroke="#999999" stroke-width="1" fill="none" />
    <line x1="39.2" y1="8.7" x2="40.5" y2="10" stroke="#999999" stroke-width="1" stroke-linecap="round" />

    <!-- Horizontal: 2×2 compact card grid -->
    <template v-if="layout === 'horizontal'">
      <!-- Card 1 -->
      <rect x="4" y="15" width="18" height="14" rx="2" stroke="#666666" stroke-width="1.2" fill="none" />
      <rect x="6" y="17" width="14" height="5" rx="1" fill="#D6D6D6" />
      <rect x="6" y="24" width="10" height="2" rx="0.5" fill="#D6D6D6" />
      <!-- Card 2 -->
      <rect x="26" y="15" width="18" height="14" rx="2" stroke="#666666" stroke-width="1.2" fill="none" />
      <rect x="28" y="17" width="14" height="5" rx="1" fill="#D6D6D6" />
      <rect x="28" y="24" width="10" height="2" rx="0.5" fill="#D6D6D6" />
      <!-- Card 3 -->
      <rect x="4" y="32" width="18" height="14" rx="2" stroke="#666666" stroke-width="1.2" fill="none" />
      <rect x="6" y="34" width="14" height="5" rx="1" fill="#D6D6D6" />
      <rect x="6" y="41" width="10" height="2" rx="0.5" fill="#D6D6D6" />
      <!-- Card 4 -->
      <rect x="26" y="32" width="18" height="14" rx="2" stroke="#666666" stroke-width="1.2" fill="none" />
      <rect x="28" y="34" width="14" height="5" rx="1" fill="#D6D6D6" />
      <rect x="28" y="41" width="10" height="2" rx="0.5" fill="#D6D6D6" />
    </template>

    <!-- Vertical: 3 stacked wide cards (image left, text right) -->
    <template v-else>
      <!-- Card 1 -->
      <rect x="4" y="15" width="40" height="9" rx="2" stroke="#666666" stroke-width="1.2" fill="none" />
      <rect x="6" y="17" width="10" height="5" rx="1" fill="#D6D6D6" />
      <rect x="18" y="17.5" width="14" height="2" rx="0.5" fill="#D6D6D6" />
      <rect x="18" y="20.5" width="9" height="1.5" rx="0.5" fill="#E0E0E0" />
      <!-- Card 2 -->
      <rect x="4" y="26.5" width="40" height="9" rx="2" stroke="#666666" stroke-width="1.2" fill="none" />
      <rect x="6" y="28.5" width="10" height="5" rx="1" fill="#D6D6D6" />
      <rect x="18" y="29" width="14" height="2" rx="0.5" fill="#D6D6D6" />
      <rect x="18" y="32" width="9" height="1.5" rx="0.5" fill="#E0E0E0" />
      <!-- Card 3 -->
      <rect x="4" y="38" width="40" height="9" rx="2" stroke="#666666" stroke-width="1.2" fill="none" />
      <rect x="6" y="40" width="10" height="5" rx="1" fill="#D6D6D6" />
      <rect x="18" y="40.5" width="14" height="2" rx="0.5" fill="#D6D6D6" />
      <rect x="18" y="43.5" width="9" height="1.5" rx="0.5" fill="#E0E0E0" />
    </template>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CardMatrixLayoutIcon',
  props: {
    layout: {
      type: String,
      default: 'horizontal',
    },
  },
});
</script>
